/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/prefer-primitives */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';
import styled from '@emotion/styled';
import { HEADER_HEIGHT, SECONDARY_NAV_WIDTH } from '../../common/constants';
export var IssueBreadcrumbs = function IssueBreadcrumbs() {
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Image, null));
};
var Wrapper = styled.div({
  position: 'fixed',
  top: "".concat(HEADER_HEIGHT, "px"),
  left: "".concat(SECONDARY_NAV_WIDTH, "px")
});
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "320",
    height: "88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 44a3 3 0 0 1 3-3h94a3 3 0 1 1 0 6H35a3 3 0 0 1-3-3ZM145 44a3 3 0 0 1 3-3h48a3 3 0 1 1 0 6h-48a3 3 0 0 1-3-3Z",
    fill: "#091E42",
    fillOpacity: ".13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.372 51.105 3.548-12.44h-1.299l-3.541 12.44h1.292Z",
    fill: "#6B778C"
  }));
};